import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import fetcher from "@/common/axiosInstance";
import UnprocessableEntityError from "@/exceptions/UnprocessableEntityError";
export var OrderPaidError = /*#__PURE__*/function (_UnprocessableEntityE) {
  function OrderPaidError() {
    var _this;
    _classCallCheck(this, OrderPaidError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, OrderPaidError, [].concat(args));
    _defineProperty(_this, "name", "OrderPaidError");
    return _this;
  }
  _inherits(OrderPaidError, _UnprocessableEntityE);
  return _createClass(OrderPaidError);
}(UnprocessableEntityError);
export var PostReservedError = /*#__PURE__*/function (_UnprocessableEntityE2) {
  function PostReservedError() {
    var _this2;
    _classCallCheck(this, PostReservedError);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _callSuper(this, PostReservedError, [].concat(args));
    _defineProperty(_this2, "name", "PostReservedError");
    return _this2;
  }
  _inherits(PostReservedError, _UnprocessableEntityE2);
  return _createClass(PostReservedError);
}(UnprocessableEntityError);
export function api__createPaymentSession(_x) {
  return _api__createPaymentSession.apply(this, arguments);
}
function _api__createPaymentSession() {
  _api__createPaymentSession = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var _res$data, _res$data2, _res$data2$data, _res$data2$data$order, _res$data3;
    var order_id, paymentProcessingUrl, gateway_type, res, _res$response, _res$response$data, _res$response$data$da, _res$response2, _res$response2$data, _res$response2$data$d;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          order_id = _ref.order_id, paymentProcessingUrl = _ref.paymentProcessingUrl, gateway_type = _ref.gateway_type;
          _context.n = 1;
          return fetcher().post("/payment-sessions/create-araboon?include=roadService,warranty,banks,payment_info,warrantyV2", _objectSpread({
            order_id: order_id,
            with_order_details: 1,
            failure_url: paymentProcessingUrl + "&in_status=failure",
            success_url: paymentProcessingUrl + "&in_status=paid"
          }, gateway_type ? {
            "preferred_gateway": gateway_type
          } : {}));
        case 1:
          res = _context.v;
          if (!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.success && res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && (_res$data2$data = _res$data2.data) !== null && _res$data2$data !== void 0 && (_res$data2$data$order = _res$data2$data.order_details) !== null && _res$data2$data$order !== void 0 && _res$data2$data$order.post_id && !Array.isArray(res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data))) {
            _context.n = 2;
            break;
          }
          return _context.a(2, {
            order_details: res.data.data.order_details,
            session: res.data.data.session
          });
        case 2:
          if (!((res === null || res === void 0 ? void 0 : (_res$response = res.response) === null || _res$response === void 0 ? void 0 : (_res$response$data = _res$response.data) === null || _res$response$data === void 0 ? void 0 : (_res$response$data$da = _res$response$data.data) === null || _res$response$data$da === void 0 ? void 0 : _res$response$data$da.error_type) == "order_already_paid")) {
            _context.n = 3;
            break;
          }
          throw new OrderPaidError('order_already_paid');
        case 3:
          if (!((res === null || res === void 0 ? void 0 : (_res$response2 = res.response) === null || _res$response2 === void 0 ? void 0 : (_res$response2$data = _res$response2.data) === null || _res$response2$data === void 0 ? void 0 : (_res$response2$data$d = _res$response2$data.data) === null || _res$response2$data$d === void 0 ? void 0 : _res$response2$data$d.error_type) == "post_reserved")) {
            _context.n = 4;
            break;
          }
          throw new PostReservedError('post_already_reserved');
        case 4:
          return _context.a(2, Promise.reject(res));
        case 5:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _api__createPaymentSession.apply(this, arguments);
}
export function api__createPaymentSessionValidation(_x2) {
  return _api__createPaymentSessionValidation.apply(this, arguments);
}
function _api__createPaymentSessionValidation() {
  _api__createPaymentSessionValidation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref2) {
    var _res$data4;
    var order_id, paymentProcessingUrl, res, _res$data5, _res$response3, _res$response3$data, _res$response3$data$d, _res$response4, _res$response4$data, _res$response4$data$d;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          order_id = _ref2.order_id, paymentProcessingUrl = _ref2.paymentProcessingUrl;
          _context2.n = 1;
          return fetcher().post("/payment-sessions/create-araboon-validation", {
            order_id: order_id,
            with_order_details: 1,
            failure_url: paymentProcessingUrl + "&in_status=failure",
            success_url: paymentProcessingUrl + "&in_status=paid",
            validation_only: 1
          });
        case 1:
          res = _context2.v;
          if (!(res !== null && res !== void 0 && (_res$data4 = res.data) !== null && _res$data4 !== void 0 && _res$data4.success)) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, !!(res !== null && res !== void 0 && (_res$data5 = res.data) !== null && _res$data5 !== void 0 && _res$data5.success));
        case 2:
          if (!((res === null || res === void 0 ? void 0 : (_res$response3 = res.response) === null || _res$response3 === void 0 ? void 0 : (_res$response3$data = _res$response3.data) === null || _res$response3$data === void 0 ? void 0 : (_res$response3$data$d = _res$response3$data.data) === null || _res$response3$data$d === void 0 ? void 0 : _res$response3$data$d.error_type) == "order_already_paid")) {
            _context2.n = 3;
            break;
          }
          throw new OrderPaidError('order_already_paid');
        case 3:
          if (!((res === null || res === void 0 ? void 0 : (_res$response4 = res.response) === null || _res$response4 === void 0 ? void 0 : (_res$response4$data = _res$response4.data) === null || _res$response4$data === void 0 ? void 0 : (_res$response4$data$d = _res$response4$data.data) === null || _res$response4$data$d === void 0 ? void 0 : _res$response4$data$d.error_type) == "post_reserved")) {
            _context2.n = 4;
            break;
          }
          throw new PostReservedError('post_already_reserved');
        case 4:
          return _context2.a(2, Promise.reject(res));
        case 5:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _api__createPaymentSessionValidation.apply(this, arguments);
}
export function api__createAribPaymentSession(_x3) {
  return _api__createAribPaymentSession.apply(this, arguments);
}
function _api__createAribPaymentSession() {
  _api__createAribPaymentSession = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref3) {
    var _res$data6, _res$data7, _res$data7$data, _res$data7$data$order, _res$data8;
    var order_id, paymentProcessingUrl, gateway_type, res, _res$response5, _res$response5$data, _res$response5$data$d, _res$response6, _res$response6$data, _res$response6$data$d;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          order_id = _ref3.order_id, paymentProcessingUrl = _ref3.paymentProcessingUrl, gateway_type = _ref3.gateway_type;
          _context3.n = 1;
          return fetcher().post("/payment-sessions/create-arib?include=roadService,warranty,banks,payment_info,warrantyV2", _objectSpread({
            order_id: order_id,
            with_order_details: 1,
            failure_url: paymentProcessingUrl + "&in_status=failure",
            success_url: paymentProcessingUrl + "&in_status=paid"
          }, gateway_type ? {
            "gateway_type": gateway_type
          } : {}));
        case 1:
          res = _context3.v;
          if (!(res !== null && res !== void 0 && (_res$data6 = res.data) !== null && _res$data6 !== void 0 && _res$data6.success && res !== null && res !== void 0 && (_res$data7 = res.data) !== null && _res$data7 !== void 0 && (_res$data7$data = _res$data7.data) !== null && _res$data7$data !== void 0 && (_res$data7$data$order = _res$data7$data.order_details) !== null && _res$data7$data$order !== void 0 && _res$data7$data$order.post_id && !Array.isArray(res === null || res === void 0 ? void 0 : (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.data))) {
            _context3.n = 2;
            break;
          }
          return _context3.a(2, {
            order_details: res.data.data.order_details,
            session: res.data.data.session
          });
        case 2:
          if (!((res === null || res === void 0 ? void 0 : (_res$response5 = res.response) === null || _res$response5 === void 0 ? void 0 : (_res$response5$data = _res$response5.data) === null || _res$response5$data === void 0 ? void 0 : (_res$response5$data$d = _res$response5$data.data) === null || _res$response5$data$d === void 0 ? void 0 : _res$response5$data$d.error_type) == "order_already_paid")) {
            _context3.n = 3;
            break;
          }
          throw new OrderPaidError('order_already_paid');
        case 3:
          if (!((res === null || res === void 0 ? void 0 : (_res$response6 = res.response) === null || _res$response6 === void 0 ? void 0 : (_res$response6$data = _res$response6.data) === null || _res$response6$data === void 0 ? void 0 : (_res$response6$data$d = _res$response6$data.data) === null || _res$response6$data$d === void 0 ? void 0 : _res$response6$data$d.error_type) == "post_reserved")) {
            _context3.n = 4;
            break;
          }
          throw new PostReservedError('post_already_reserved');
        case 4:
          return _context3.a(2, Promise.reject(res));
        case 5:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return _api__createAribPaymentSession.apply(this, arguments);
}
export function api__createAribPaymentSessionValidation(_x4) {
  return _api__createAribPaymentSessionValidation.apply(this, arguments);
}
function _api__createAribPaymentSessionValidation() {
  _api__createAribPaymentSessionValidation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref4) {
    var _res$data9;
    var order_id, paymentProcessingUrl, res, _res$data0, _res$response7, _res$response7$data, _res$response7$data$d, _res$response8, _res$response8$data, _res$response8$data$d;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          order_id = _ref4.order_id, paymentProcessingUrl = _ref4.paymentProcessingUrl;
          _context4.n = 1;
          return fetcher().post("/payment-sessions/create-arib-validation", {
            order_id: order_id,
            with_order_details: 1,
            failure_url: paymentProcessingUrl + "&in_status=failure",
            success_url: paymentProcessingUrl + "&in_status=paid",
            validation_only: 1
          });
        case 1:
          res = _context4.v;
          if (!(res !== null && res !== void 0 && (_res$data9 = res.data) !== null && _res$data9 !== void 0 && _res$data9.success)) {
            _context4.n = 2;
            break;
          }
          return _context4.a(2, !!(res !== null && res !== void 0 && (_res$data0 = res.data) !== null && _res$data0 !== void 0 && _res$data0.success));
        case 2:
          if (!((res === null || res === void 0 ? void 0 : (_res$response7 = res.response) === null || _res$response7 === void 0 ? void 0 : (_res$response7$data = _res$response7.data) === null || _res$response7$data === void 0 ? void 0 : (_res$response7$data$d = _res$response7$data.data) === null || _res$response7$data$d === void 0 ? void 0 : _res$response7$data$d.error_type) == "order_already_paid")) {
            _context4.n = 3;
            break;
          }
          throw new OrderPaidError('order_already_paid');
        case 3:
          if (!((res === null || res === void 0 ? void 0 : (_res$response8 = res.response) === null || _res$response8 === void 0 ? void 0 : (_res$response8$data = _res$response8.data) === null || _res$response8$data === void 0 ? void 0 : (_res$response8$data$d = _res$response8$data.data) === null || _res$response8$data$d === void 0 ? void 0 : _res$response8$data$d.error_type) == "post_reserved")) {
            _context4.n = 4;
            break;
          }
          throw new PostReservedError('post_already_reserved');
        case 4:
          return _context4.a(2, Promise.reject(res));
        case 5:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return _api__createAribPaymentSessionValidation.apply(this, arguments);
}